import { render, staticRenderFns } from "./RbuAdjustment.vue?vue&type=template&id=e328cd50"
import script from "./RbuAdjustment.vue?vue&type=script&lang=js"
export * from "./RbuAdjustment.vue?vue&type=script&lang=js"
import style0 from "./RbuAdjustment.vue?vue&type=style&index=0&id=e328cd50&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports